"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colomnRecommendSlider = void 0;
/* ========================================================================
    Module: Column recommend slider
 ========================================================================== */
const swiper_1 = __importStar(require("swiper"));
const util_1 = require("~modules/util");
const breakPointMedium = (0, util_1.getCssPropertyValue)("--uk-breakpoint-m");
const breakPointLarge = (0, util_1.getCssPropertyValue)("--uk-breakpoint-l");
let swiper;
/**
 * コラムのおすすめスライダーを設定する
 *
 * @returns {void}
 */
const colomnRecommendSlider = () => {
    if (swiper) {
        swiper.destroy();
        document
            .querySelector(".js-swiper .swiper-button-next")
            ?.classList.remove("swiper-button-lock");
        document
            .querySelector(".js-swiper .swiper-button-prev")
            ?.classList.remove("swiper-button-lock");
    }
    const swiperWrap = document.querySelector(".js-swiper-wrap");
    if (!swiperWrap) {
        return;
    }
    const swiperSliderItems = swiperWrap.querySelectorAll(".swiper-slide");
    let loop = false;
    if (swiperSliderItems.length > 1) {
        loop = true;
    }
    if (window.matchMedia(`(min-width: ${breakPointMedium})`).matches) {
        loop = swiperSliderItems.length > 2 ? true : false;
    }
    if (window.matchMedia(`(min-width: ${breakPointLarge})`).matches) {
        loop = swiperSliderItems.length > 3 ? true : false;
    }
    swiper = new swiper_1.default(".js-column-recommend", {
        modules: [swiper_1.Autoplay, swiper_1.Navigation],
        loop: loop,
        slidesPerView: 1,
        spaceBetween: 70,
        breakpoints: {
            [parseInt(breakPointMedium)]: {
                slidesPerView: 2,
                spaceBetween: 70,
            },
            [parseInt(breakPointLarge)]: {
                slidesPerView: 3,
                spaceBetween: 70,
            },
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
};
exports.colomnRecommendSlider = colomnRecommendSlider;
